// Due-date urgency for the card indicator. Returns null when there is no due date
// (migrated records have none) so the card simply shows no urgency flag — never a
// false "overdue". Only meaningful for active (pre-outcome) proposals; the board
// suppresses it on outcome cards.
export function dueUrgency(dueDate, now = new Date()) {
  if (!dueDate || typeof dueDate !== "string") return null;
  const due = new Date(dueDate + (dueDate.length === 10 ? "T00:00:00" : ""));
  if (Number.isNaN(due.getTime())) return null;
  const midnight = new Date(now);
  midnight.setHours(0, 0, 0, 0);
  const days = Math.round((due - midnight) / 86400000);
  if (days < 0) return { level: "overdue", label: `${Math.abs(days)}d overdue`, days };
  if (days === 0) return { level: "overdue", label: "due today", days };
  if (days <= 7) return { level: "soon", label: `due in ${days}d`, days };
  if (days <= 30) return { level: "upcoming", label: `due in ${days}d`, days };
  return { level: "later", label: `due ${due.toLocaleDateString("en-US", { month: "short", day: "numeric" })}`, days };
}

export const URGENCY_STYLE = {
  overdue:  { color: "#ef4444", bg: "rgba(239,68,68,0.12)",  border: "rgba(239,68,68,0.35)" },
  soon:     { color: "#f59e0b", bg: "rgba(245,158,11,0.12)", border: "rgba(245,158,11,0.35)" },
  upcoming: { color: "#67e8f9", bg: "rgba(103,232,249,0.10)", border: "rgba(103,232,249,0.30)" },
  later:    { color: "#94a3b8", bg: "rgba(148,163,184,0.10)", border: "rgba(148,163,184,0.25)" },
};
